import React, { ReactElement, useState } from 'react';
import Link from 'next/link';
import LinesEllipsis from 'react-lines-ellipsis';
import { ISrcSet, Picture } from '@kursk/components/ui/Picture/Picture';
import styles from './RecommendationsSingle.module.scss';
import moment from "moment";
import { ITicketsBundles } from "@common/redux/types/ticketsBundles";
import { getPriceTitle } from '@kursk/utils/getPriceTitle';

interface IPlaceCardProps {
  entity: any;
  link: string;
  entityType?: string;
  newTab?: boolean;
}

export function RecommendationsSingle({ entity, link, entityType, newTab = false }: IPlaceCardProps): ReactElement {
  const [isHover, setIsHover] = useState(false);

  const imgSrcSet: ISrcSet[] = [
    {
      media: '(min-width: 0px)',
      width: 270,
      height: 241,
      cropMode: 'noCrop',
    }
  ];


  return (
    <Link href={`${link}/${entity._id}/${entity.sysName}`} passHref>
      <a target={newTab ? '_blank' : undefined}>
        <div
          className={styles.wrapper}
          onMouseOver={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <div className={styles.badge}>
            {entityType === 'ticketsbundles' ? 'абонемент' : entityType === 'streams' ?
              'трансляции' : entity.category?.name}
          </div>
          <Picture className={styles.image} srcSet={imgSrcSet} image={entity.image}/>
          <div className={styles.info}>
            {entityType === 'ticketsbundles' && (
              <div className={styles.expire}>
                {`Истекает ${moment((entity as ITicketsBundles).end).format('D MMMM YYYY')}`}
              </div>
            )}
            {entityType === 'streams' && <div className={styles.streams_date}>
              {moment(entity.start).format('D MMMM YYYY, H:mm')}
            </div>}
            <LinesEllipsis
              text={entity.name}
              maxLine={isHover ? 4 : 3}
              ellipsis='...'
              trimRight
              basedOn='letters'
              className={styles.title}
            />
            {entityType === 'ticketsbundles' && (
              <p className={styles.price}>{
                getPriceTitle(entity.minPrice, entity.maxPrice)
              }</p>
            )}
            {entityType === 'places' && entity?.ticketsInfo?.available > 0 && (
              <p className={styles.price}>{
                getPriceTitle(entity.ticketsInfo.minPrice, entity.ticketsInfo.maxPrice)
              }</p>
            )}
          </div>
        </div>
      </a>
    </Link>
  );
}
